var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "enroll-audit-page" },
    [
      _c("yxt-page-header", {
        attrs: { title: _vm.language().tit_sign_up },
        on: { back: _vm.backRouter },
      }),
      _c("audit-detail", {
        attrs: { loading: _vm.loading, record: _vm.record },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }